var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"id":_vm.id,"hide-header":true,"hide-footer":true}},[_c('div',{staticClass:"modal-body p-0",attrs:{"slot":"body"},slot:"body"},[(!!_vm.course)?_c('DetailsPane',{attrs:{"course":_vm.course,"tab":_vm.tab},on:{"close":function($event){return _vm.close()}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }